import { customAxios } from "apis/axios/customAxios";
import { GET_URL_ARCHIVE_INFO } from "constants/apiUrls";
import { Archive } from "types/archive";

const getArchive = (url: string, year: number) => {
  return customAxios
    .get<Archive>(GET_URL_ARCHIVE_INFO(url, year))
    .then((res) => res.data);
};

export { getArchive };

